var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "vuesax/outline/message-notif"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Arrow - Right 2",
    d: "M9.435 16.677a.489.489 0 01-.048-.646l.048-.054L13.487 12 9.435 8.024a.489.489 0 01-.048-.647l.048-.055a.514.514 0 01.659-.045l.057.045 4.414 4.327a.489.489 0 01.049.646l-.049.056-4.414 4.326a.513.513 0 01-.716 0z",
    fill: "#0a090e",
    stroke: "#0a090e",
    strokeWidth: 0.5
  }))));
}
export default SvgVuesaxOutlineChevronRight;